import styled from 'styled-components';
import { color } from '../../../shared/styles';

export const ContentWrapper = styled.div`
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 24px;
    border-radius: 5px;
    background-color: ${color.emphasis.NEUTRAL_N0};
    flex: 1;
    overflow: hidden;
    border: 1px solid ${color.secondary.BORDER};
    box-shadow: none;
    height: 100%;
`;

export const SingleProductContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
`;

export const ProductTableText = styled.div`
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
    border-left: 5px solid var(--Primary-Blue-B100, #0058a0);
    padding-left: 20px;
`;

export const ProductButtonRow = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const DoubleColumnWrapper = styled.div`
    overflow: hidden;
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 24px;
    height: auto;
    width: 100%;
`;

export const SecondColumn = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: 24px;
`;

export const InfoBoxWrapper = styled.div`
    background-color: white;
    border-radius: 5px;
    min-height: fit-content;
    border: 1px solid ${color.secondary.BORDER};
    box-shadow: none;
    height: auto;
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;

    .text {
        font-family: Noto Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
`;

export const InfoBoxTitle = styled.div`
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
`;
